import { combineReducers } from 'redux'
import article from './article-editor';

const articles = combineReducers({
  article,
});

export default articles;
